module.exports = __webpack_public_path__ + "img/project_whzb1.ebf18ca4.png";